import React, { useContext, useLayoutEffect, useState } from 'react';
import I18n from 'i18n-js';
import Modal from '@/components/common/Modal';
import DndAnswerContext from '@/components/common/Context';
import useSlideShowStore from '@/components/admin/SlideShow/stores/useSlideShowStore';
import Answer from '../index';
import styles from './DraggableChoicesBank.module.scss';

const AnswerKeyButton = () => {
  const { locale, question } = useContext(DndAnswerContext);
  const isPresentMode = useSlideShowStore(state => state.isPresentMode);
  const [isOpen, setIsOpen] = useState(false);
  const [parentNode, setParentNode] = useState(null);

  const parent = isPresentMode ? '.slide' : '.current-slide';

  useLayoutEffect(() => {
    setParentNode(document.querySelector(parent));

    return () => setParentNode(null);
  }, []);

  if (!parentNode) return null;

  return (
    <>
      <button
        className={`${styles.answerKeyButton} btn btn--sm btn--outline-dark-orange mt5`}
        type="button"
        onClick={() => setIsOpen(prev => !prev)}
      >
        {I18n.t('show_answer_key')}
      </button>
      <Modal
        nearlyFullScreen
        bodyClassName="tw-overflow-hidden"
        bodyId={`drag-and-drop-answer-modal-${question.id}`}
        closeModal={() => setIsOpen(false)}
        headerClass={styles.answerKeyModalHeader}
        headerText="Answer Key"
        isOpen={isOpen}
        overlayClassName={styles.answerKeyModal}
        parentSelector={() => parentNode}
      >
        <Answer
          showAnswerKey
          locale={locale}
          parentContainerId={`drag-and-drop-answer-modal-${question.id}`}
          question={question}
        />
      </Modal>
    </>
  );
};

export default AnswerKeyButton;
